import { Box, CircularProgress, Grid2, IconButton, styled } from '@mui/material'
import { FC } from 'react'
import { QuotationData } from './QuotationData'
import { useMaintenanceTicketsContext } from '@/context/MaintenanceTicketsContext'
import AddIcon from '@/assets/icons/actions/add.svg'

const IconButtonStyled = styled(IconButton)({
  outline: 'none',
  '&:focus': {
    outline: 'none',
  },
})

interface QuotationFormProps {
  quotationData: Quotation[]
  setQuotationData: React.Dispatch<React.SetStateAction<Quotation[]>>
  ticketId: number
  disabled: boolean
}

type Attachment = {
  id: number
  fileName: string
  presignedUrl: string
  fileType: string
  attachmentType: string
}

type Quotation = {
  contractorName: string
  amount: string | number
  remark: string
  isAwarded: boolean
  attachments: Attachment[]
  dateCreated: string
  contractorId?: string | number
}
export const QuotationForm: FC<QuotationFormProps> = ({
  quotationData,
  setQuotationData,
  ticketId,
  disabled,
}) => {
  const { contractorQuotationState } = useMaintenanceTicketsContext()

  const handleAddQuotation = () => {
    setQuotationData([
      ...quotationData,
      {
        contractorName: '',
        contractorId: 0,
        amount: '',
        remark: '',
        isAwarded: false,
        attachments: [],
        dateCreated: '',
      },
    ])
  }

  const handleDeleteQuotation = (index: number) => {
    setQuotationData((prev) => prev.filter((_value, i) => i !== index))
  }

  const handleChange = (
    index: number,
    field: string,
    value: string | boolean | number | Attachment | Attachment[],
  ) => {
    if (field === 'isAwarded') {
      setQuotationData((prev) =>
        prev.map((item, i) => {
          if (i === index) {
            if (typeof value === 'boolean') {
              return { ...item, [field]: value }
            }
          }
          return { ...item, [field]: false }
        }),
      )
    } else {
      setQuotationData((prev) =>
        prev.map((item, i) => {
          if (i !== index) return item
          return { ...item, [field]: value }
        }),
      )
    }
  }

  const handleAddAttachment = (index: number, value: Attachment) => {
    setQuotationData((prev) =>
      prev.map((item, i) => {
        if (i !== index) return item

        return {
          ...item,
          attachments: [...(item.attachments || []), value],
        }
      }),
    )
  }

  const handleDelete = (attachmentIndex: number, index: number) => {
    setQuotationData((prev) =>
      prev.map((item, i) => {
        if (i !== index) return item

        return {
          ...item,
          attachments: item.attachments.filter(
            (_, idx) => idx !== attachmentIndex,
          ),
        }
      }),
    )
  }

  return (
    <Box>
      {contractorQuotationState.isLoading ? (
        <Box display="flex" justifyContent="center">
          <CircularProgress size={24} color="inherit" />
        </Box>
      ) : (
        <>
          {quotationData?.map((data, index) => (
            <Box key={index}>
              <QuotationData
                data={data}
                onChange={handleChange}
                onDelete={handleDeleteQuotation}
                handleAddAttachment={handleAddAttachment}
                handleDeleteAttachment={handleDelete}
                index={index}
                ticketId={ticketId}
                disabled={disabled}
              />
            </Box>
          ))}
          {!disabled && (
            <Grid2 container display="flex" justifyContent="center">
              <IconButtonStyled
                onClick={handleAddQuotation}
                disabled={disabled}
              >
                <img src={AddIcon} alt="View" width={30} height={30} />
              </IconButtonStyled>
            </Grid2>
          )}
        </>
      )}
    </Box>
  )
}
